<template>
  <div>
    <section class="login-wrap">
      <div class="login-flex">
        <figure>
          <img src="@/assets/img/login-image.png" alt="" />
        </figure>
        <div class="login-form">
          <div class="padding-big">
            <p class="login-title">사용하실 라이선스를 선택해주세요</p>
            <div class="radio-wrap">
              <input type="radio" name="level" id="lite" checked />
              <label for="lite">LITE</label>
              <input type="radio" name="level" id="pro" />
              <label for="pro">PRO</label>
            </div>
            <div>
              <input type="text" class="login-init id" v-model="id" placeholder="아이디를 입력해주세요." />
            </div>
            <div class="mt20">
              <input type="password" class="login-init pw" v-model="pw" placeholder="비밀번호를 입력해주세요." />
            </div>
            <br />
            <div style="display: flex" class="check-group">
              <input type="checkbox" id="chkSaveId" v-model="chkSaveId" />
              <label for="chkSaveId" style="padding-top: 0px; padding-bottom: 0px; vertical-align: top">아이디 저장</label>
              <div class="line">|</div>
              <div class="ckbox" style="padding-left: 30px">
                <input type="checkbox" id="chkAutoLogin" v-model="chkAutoLogin" />
                <label for="chkAutoLogin">자동로그인</label>
              </div>
            </div>
            <div class="mt50">
              <button type="submit" class="btn-login" @click="login()" :disabled="id.trim() == '' || pw.trim() == ''">로그인</button>
              <!-- testdata = {{ getTestData }} -->
            </div>
          </div>
          <div class="alert" v-if="loginCheck == false">
            <img :src="require('@/assets/images/alert.png')" alt="" />
            {{ this.errorMsg }}
          </div>
        </div>
      </div>
      <div class="ip-check" @click="clickIPCheck">IP 체크하기</div>
    </section>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
import store from '../../store/store';
import $ from 'jquery';
export default {
  data() {
    return {
      getApiData: null,
      osType: '',
      id: '',
      pw: '',
      loginCheck: true,
      cookieUserId: '',
      cookieAutoLogin: 'N',
      cookieUserPw: '',
      chkSaveId: true,
      chkAutoLogin: true,
      loginEncrypt: null,
      getTestData: null,
      errorMsg: null
    };
  },
  mounted: function () {
    window.receiveDeviceInfo = this.receiveDeviceInfo;
    window.receiveGetApi = this.receiveGetApi;
    window.receivePostApi = this.receivePostApi;

    this.cookieUserId = Cookies.get('cookieUserId');
    this.cookieAutoLogin = Cookies.get('cookieAutoLogin');
    this.cookieUserPw = Cookies.get('cookieUserPw');

    if (this.cookieAutoLogin == 'Y') {
      //this.autoLogin();
    } else {
      this.chkAutoLogin = false;
    }

    if (this.cookieUserId != null) {
      this.id = this.cookieUserId;
      this.chkSaveId = true;
    } else {
      this.chkSaveId = false;
    }

    this.pw = '';
  },
  methods: {
    // login2() {
    // 	let temp = $('#lite').is(':checked') == true ? '1' : '2';
    // 	alert(temp);
    // },
    async login() {
      let d = new Date();
      d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000); //30일세팅 맨앞자리 숫자 세팅. 쿠키서 보면 expires날짜가 30일뒤로 세팅.
      let expires = 'expires=' + d.toUTCString();

      this.$store.commit('login', this.id);
      const aesKey = '08a0d3a6ec32e85e';
      let plainText = '';
      //라이선스 타입
      this.$store.state.settingInfo.licenseType = $('#lite').is(':checked') == true ? '1' : '2';

      // 로컬 개발일 경우
      if (this.$store.state.serverType === '1') {
        plainText = {
          id: this.id,
          pw: this.pw,
          uid: 'web dev',
          licenseType: $('#lite').is(':checked') == true ? '1' : '2',
          deviceId: 'deviceId web dev',
          token: 'token web dev',
          jwtKey: '',
          deviceInfo: {
            model: 'model web dev',
            appVer: 'appVer web dev',
            webVer: 'webVer web dev',
            agentIp: 'agentIp web dev',
            agentPort: 'agentPort web dev'
          }
        };
        plainText = JSON.stringify(plainText);
      }
      //배포일 경우
      else {
        plainText = {
          id: this.id,
          pw: this.pw,
          uid: this.$store.state.deviceInfo.deviceId,
          licenseType: $('#lite').is(':checked') == true ? '1' : '2',
          deviceId: this.$store.state.deviceInfo.deviceId,
          token: this.$store.state.deviceInfo.token,
          jwtKey: '',
          deviceInfo: {
            model: this.$store.state.deviceInfo.model,
            appVer: this.$store.state.deviceInfo.version,
            webVer: this.$store.state.storeWebVersion,
            osType: this.$store.state.deviceInfo.osType,
            osVersion: this.$store.state.deviceInfo.osVersion,
            agentIp: this.$store.state.deviceInfo.ip,
            agentPort: this.$store.state.deviceInfo.port
          }
        };
        plainText = JSON.stringify(plainText);
      }

      let key = this.CryptoJS.enc.Utf8.parse(aesKey);
      let iv = this.CryptoJS.enc.Hex.parse('00000000000000000000000000000000');
      let encrypt = this.CryptoJS.AES.encrypt(plainText, key, { iv: iv });

      if (store.state.serverType === '1') {
        this.$axios.defaults.baseURL = `${this.$store.state.apiDomain}`;
      }
      try {
        let url = '/login';
        if (this.$osType === 'web' || this.$osType === 'ios') {
          await this.$axios
            .post(url, {
              loginInfo: encrypt.toString()
            })
            .then((response) => {
              if (response.data.state == 'success') {
                //라이선스 타입 옵션 설정에 저장
                let json = JSON.stringify({
                  licenseType: $('#lite').is(':checked') == true ? '1' : '2'
                });
                this.$util.setOption(json);
                this.$store.commit('login', response.data.data);
                this.$router.push({
                  name: '대기리스트'
                });
                if (this.chkSaveId == true) {
                  document.cookie = 'cookieUserId=' + this.id + ';' + expires + ';path=/';
                }

                if (this.chkAutoLogin == true) {
                  document.cookie = 'cookieUserId=' + this.id + ';' + expires + ';path=/';
                  document.cookie = 'cookieAutoLogin=Y;' + expires + ';path=/';
                  document.cookie = 'cookieUserPw=' + encrypt.toString() + ';' + expires + ';path=/';
                } else {
                  document.cookie = 'cookieAutoLogin=N;' + expires + ';path=/';
                }
              } else {
                this.errorMsg = response.data.errorMsg;
                this.loginCheck = false;
              }
            })
            .catch((e) => {
              this.loginCheck = false;
              console.log(e);
            });
        } else {
          //ANDROID,IOS 처리
          let apiPostData = JSON.stringify({
            url: `${this.$store.state.apiDomain}/login`,
            param: {
              loginInfo: encrypt.toString()
            }
          });
          let result = await this.$util.postApi(apiPostData);

          //this.getTestData = result;
          if (result.state == 'success') {
            //라이선스 타입 옵션 설정에 저장
            let json = JSON.stringify({
              licenseType: $('#lite').is(':checked') == true ? '1' : '2'
            });
            this.$util.setOption(json);

            this.$store.commit('login', result.data);
            this.$router.push({
              name: '대기리스트'
            });
            if (this.chkSaveId == true) {
              document.cookie = 'cookieUserId=' + this.id + ';' + expires + ';path=/';
            }

            if (this.chkAutoLogin == true) {
              document.cookie = 'cookieAutoLogin=Y;' + expires + ';path=/';
              document.cookie = 'cookieUserPw=' + encrypt.toString() + ';' + expires + ';path=/';
            } else {
              document.cookie = 'cookieAutoLogin=N;' + expires + ';path=/';
            }
          } else {
            this.errorMsg = result.errorMsg;
            this.loginCheck = false;
          }
        }
      } catch (e) {
        alert(e);
        console.log(e);
        //alert(`로그인 postApi 시도 에러 = ${e}`);
      }
    },
    clickIPCheck() {
      try {
        var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
        if (varUA.match('android') != null) {
          window.penchart.callChangeAddress();
        } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
          //IOS 일때 처리
          window.webkit.messageHandlers.callChangeAddress.postMessage('');
        }
      } catch (e) {
        alert(e);
      }
    },
    receiveDeviceInfo(json) {
      try {
        //디바이스 정보로 얻은것 api 도메인 세팅
        let url = `http://${json.ip}:${json.port}`;
        this.$axios.defaults.baseURL = url;
        this.$store.state.apiDomain = url;
        this.$store.commit('deviceInfo', json);
        this.ip = json.ip;
        this.port = json.port;
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped src="../../assets/css/page/login.css"></style>
